// src/pages/ProjectList.jsx
import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PageLines from "../components/PageLines";
import ProjectCard from "../components/ProjectCard";
import useStickyNavbar from "../hooks/useStickyNavbar";
import ContactSection from "../components/ContactSection";
import CustomLoader from "../components/CustomLoader";

// Firestore imports
import { db } from "../firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";

export default function ProjectList() {
  useStickyNavbar();

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide loader after 2 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    async function fetchProjects() {
      try {
        const q = query(collection(db, "projects"), orderBy("title"));
        const snapshot = await getDocs(q);
        const items = snapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            title: data.title,
            category: data.category,
            imageUrl: data.imageUrl1 || data.imageUrl,
            websiteUrl: data.websiteUrl,
            light: data.light,
          };
        });
        setProjects(items);
      } catch (err) {
        console.error("Error loading projects:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchProjects();
  }, []);

  // Re-init Magnific Popup once projects have rendered
  useEffect(() => {
    if (!loading && window.jQuery && window.jQuery.fn.magnificPopup) {
      window.jQuery(".js-projects-gallery").magnificPopup({
        delegate: "a",
        type: "image",
        gallery: { enabled: true, navigateByImgClick: true, preload: [0, 1] },
        image: { titleSrc: (item) => item.el.attr("title") },
      });
    }
  }, [loading]);

  return (
    <div className="layout">
      {/* Custom Loader */}
      {isLoading && <CustomLoader />}
      {/* Navbar */}
      <Navbar />

      {/* Hero/banner */}
      <main
        className="main main-inner main-projects bg-projects"
        style={{
          backgroundImage: "url('/img/xinchuan/xinchuan_office2.jpg')",
          backgroundSize: "cover",
        }}
        data-stellar-background-ratio="0.6"
      >
        <div className="container">
          <header className="main-header">
            <h1>Projects</h1>
          </header>
        </div>
        <PageLines />
      </main>

      <div className="content">
        {/* Projects grid */}
        <section className="projects">
          <div className="js-projects-gallery">
            <div className="row">
              {loading ? (
                <p>Loading projects…</p>
              ) : (
                projects.map((p) => (
                  <ProjectCard
                    key={p.id}
                    img={p.imageUrl}
                    title={p.title}
                    category={p.category}
                    websiteUrl={p.websiteUrl}
                    light={p.light}
                  />
                ))
              )}
            </div>
          </div>

          {projects.length > 8 && (
            <div className="section-content text-center">
              <button className="btn btn-gray" disabled>
                More projects
              </button>
            </div>
          )}
        </section>

        {/* Footer */}
        <ContactSection />
        <Footer />
        <PageLines />
      </div>
    </div>
  );
}